import { render } from "./Ambassadors.vue?vue&type=template&id=075cdd29&scoped=true"
import script from "./Ambassadors.vue?vue&type=script&lang=js"
export * from "./Ambassadors.vue?vue&type=script&lang=js"

import "./Ambassadors.vue?vue&type=style&index=0&id=075cdd29&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075cdd29"]])

export default __exports__